import React, { Component } from 'react';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory from 'react-bootstrap-table2-editor';
import filterFactory from 'react-bootstrap-table2-filter';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
// import overlayFactory from 'react-bootstrap-table2-overlay';
import paginationFactory, {
	PaginationProvider,
	PaginationListStandalone,
	PaginationTotalStandalone,
	SizePerPageDropdownStandalone
} from 'react-bootstrap-table2-paginator';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'App.css';
import { ADD_TOAST_MESSAGE } from '../../../../Redux/Enums/Contracts.Globals.Enums';
import {
	onStartEdit,
	unhideRows,
	showRows,
	areRowsHidden,
	AmendmentInfo,
	UnhideButton,
	getEditState,
	setUnhideStatus,
	getUpdateRowEdit
} from './Helpers/RowEditHelpers';
import YearSelector from 'Common/Components/year-selector/YearSelector.container';
import Groupings from 'Common/Constants/Groupings';


class ContractsDataTable extends Component {
	constructor(props) {
		super(props);
		
		this.onStartEdit = onStartEdit.bind(this);
		const isScriptDates = (props.tableName && props.tableName == 'script-dates');
		this.state = {
			columns: props.columns(this.onStartEdit),
			keyField: props.keyField,
			pageNo: 1,
			pageSize: 10,
			searchText: '',
			displayTotal: isScriptDates ? props.dataTableTotal : props.count.total,
			inPreview: false,
			isLoaded: false,
			qualification_year: props.year.toString(),
			isScriptDates,			
			key: Math.random(),
			...getEditState({ searchRef: 'searchComponentRef' })
		};
		this.componentRef = React.createRef();
		this.searchComponentRef = React.createRef();

		this.unhideRows = unhideRows.bind(this);
		this.areRowsHidden = areRowsHidden.bind(this);
		this.getUpdateRowEdit = getUpdateRowEdit.bind(this);
		this.showRows = showRows.bind(this);
		this.setUnhideStatus = setUnhideStatus.bind(this);
	}

	componentDidMount = async () => {
		if (!this.state.isScriptDates) {
			this.setState({ ...this.state, isLoaded: false });
			const { year, contractTypes, handleGetData, handleClearUpdates } = this.props;
			handleClearUpdates();
			const { pageNo, pageSize } = this.state;
			let query = {
				sortOrder: 'asc',
				sortField: 'title',
				page: pageNo,
				sizePerPage: pageSize,
				searchText: '',
				flagExportData: false
			};
			await handleGetData(contractTypes, year, query); 
		}
	};

	static getDerivedStateFromProps(props, state) {
		const {
			data,
			count,
			dataTableTotal
		} = props;
		const { searchText, isScriptDates } = state;
		const total = isScriptDates ? dataTableTotal : count.total;
		const displayTotal = searchText !== '' ? data.length : total;

		return {
			displayTotal,
			isSearch: false,
			isLoaded: true
		};
	}

	componentDidUpdate() {
		const { fireShow, setFireShow, amendments } = this.props;

		if (fireShow) {
			this.showRows();
			setFireShow(false);
		}

		if (amendments === 0) {
			this.removePreview();
		}

		this.setUnhideStatus();
	}

	componentWillUnmount = () => this.props.handleClearUpdates();

	handleTableChange = async (type, state) => {
		let { sortOrder, sortField, page, sizePerPage, searchText } = state;
		const { year, contractTypes, handleGetData } = this.props;
		sortOrder = sortOrder ? sortOrder : 'asc';
		sortField = sortField ? sortField : 'title';
		page = type === 'search' ? 1 : page;
		const query = {
			sortOrder,
			sortField,
			page,
			sizePerPage,
			searchText,
			flagExportData: false
		};
		if (this.state.isScriptDates) {
			const exportData = false, isRefine = false;
			const { selectedTypes, year, selectedTeamIds, refineFields, setPageDetails, resetPageNo, groupUpdaterFields } = this.props;
			await handleGetData(selectedTypes, year, query, exportData, selectedTeamIds, isRefine, refineFields, groupUpdaterFields);
			setPageDetails && setPageDetails(sizePerPage);
			resetPageNo && resetPageNo(false);
		}
		else {
			await handleGetData(contractTypes, year, query);
		}

		const updateRowEdit = this.getUpdateRowEdit(searchText);
		this.setState({ ...this.state, pageNo: page, pageSize: sizePerPage, searchText, ...updateRowEdit });
		this.componentRef.scrollIntoView({ behavior: 'smooth' });
	};

	handleGetExportData = async props => {
		const { year, contractTypes, handleGetData } = this.props;
		let exportData = true;
		const query = {
			sortOrder: 'asc',
			sortField: 'title',
			page: 0,
			sizePerPage: 0,
			searchText: '',
			flagExportData: true
		};
		if (this.state.isScriptDates) {
			const isRefine = false;
			const { selectedTypes, selectedTeamIds, refineFields, groupUpdaterFields } = this.props;
			await handleGetData(selectedTypes, year, query, exportData, selectedTeamIds, isRefine, refineFields, groupUpdaterFields);
		}
		else {
			await handleGetData(contractTypes, year, query, exportData);
		}
		props.onExport(this.props.all_data);
	};

	displayWarning = message => {
		const { dispatch } = this.props;
		dispatch({ type: ADD_TOAST_MESSAGE, payload: { severity: 'warning', message } });
	};

	checkEditability = (oldValue, newValue, row, column, done) => {
		const { inPreview } = this.state;
		let editable = true;

		if (inPreview) {
			editable = false;
			this.displayWarning('To edit please exit preview');
		}

		setTimeout(() => (editable ? done() : done(false)), 100);
		return { async: true };
	};

	checkUpdate = (field, val, rowData) => {
		const { dataCopy, updated, handleAddUpdates } = this.props;
		const isInOriginalData = dataCopy.find(rowCopy => isEqual(rowCopy, rowData));

		if (!isInOriginalData) {
			const _rowData = cloneDeep(rowData);
			handleAddUpdates(field, val, _rowData, updated);
		} else {
			const { removeUpdate, keyField } = this.props;
			removeUpdate(keyField, rowData[keyField], updated);
		}
	};

	removeAllEdits = () => {
		const { handleRemoveAllEdits } = this.props;
		handleRemoveAllEdits();
	};

	previewClick = () => {
		const { inPreview } = this.state;
		this.setState({ inPreview: !inPreview });
	};

	removePreview = () => {
		const { inPreview } = this.state;
		if (inPreview) {
			this.setState({ inPreview: false });
		}
	};

	updateYear = async updateYearprop => {     
				
		this.state.qualification_year = updateYearprop;
		this.setState({ ...this.state, isLoaded: false });

		const { handleGetCount, contractTypes, handleGetData, handleClearUpdates, updateQualYear } = this.props;
		handleClearUpdates();

		let query = {
			sortOrder: 'asc',
			sortField: 'title',
			page: 1,
			sizePerPage: 10,
			searchText: '',
			flagExportData: false
		};
		
		//	Reset the paging
		this.setState({ ...this.state, pageNo: 1, pageSize: 10, searchText: '' });

		//	Update root page
		updateQualYear(this.state.qualification_year);
		
		//refreash the data
		await handleGetData(contractTypes, this.state.qualification_year, query);

		//	Reset the count
		handleGetCount(contractTypes, this.state.qualification_year);
				
		//	Refresh the pagination
		this.setState({ key: Math.random() });
	};

	

	render() {
		const { SearchBar, ClearSearchButton } = Search;
		const { keyField, columns, pageSize, hiddenRows, inPreview, isScriptDates } = this.state;

		const {
			tableName = '',
			data,
			contractTypes,
			updated,
			amendments,
			count,
			dataTableTotal,
			isPageReset
		} = this.props;

		const CustomCsvButton = props => (
			<button
				className="react-bs-table-csv-btn btn btn-default btn-primary"
				style={{ height: '45px', width: '200px' }}
				onClick={() => this.handleGetExportData(props)}
			>
				Export CSV
			</button>
		);

		const hasAmendments = amendments > 0;		
		const viewData = inPreview ? updated : data;
		const showPagination = !this.areRowsHidden() && !inPreview;
		const total = isScriptDates ? dataTableTotal : count.total;		
		const pageNo = (isScriptDates && isPageReset) ? 1 : this.state.pageNo;

		return (
			<div ref={el => (this.componentRef = el)} className={tableName}>

				{!isScriptDates && (<YearSelector numberOfPreviousYears={1} numberOfFutureYears={1} year={this.state.qualification_year.toString()} grouping={Groupings.Marker} updateYear={this.updateYear} />)}

				<PaginationProvider
					pagination={paginationFactory({
						custom: true,
						totalSize: isScriptDates ? dataTableTotal : this.state.displayTotal,
						page: pageNo,
						sizePerPage: pageSize,
						showTotal: true,
						withFirstAndLast: true,
						alwaysShowAllBtns: true
					})}
					key={this.state.key}
					keyField={keyField}
					columns={columns}
					data={viewData}
				>
					{({ paginationProps, paginationTableProps }) => (

						<ToolkitProvider
							keyField={keyField}
							columns={columns}
							data={viewData}
							search={{ placeholder: 'Search...' }}
							exportCSV={{
								fileName: `contract_management_${contractTypes.join('_')}.csv`,
								separator: ','
							}}
						>
							{toolkitProps => {
								const { searchText } = toolkitProps.searchProps;
								return (
									<div className="container-fluid">
										{showPagination && (
											<div
												style={{
													display: 'flex',
													flexDirection: 'row',
													justifyContent: 'space-between',
													flexWrap: 'wrap'
												}}
											>
												<div>
													{isScriptDates ? (<span className="scriptDatesPagingSpace"></span>) : (
														<>
															<SearchBar ref={el => (this.searchComponentRef = el)} {...toolkitProps.searchProps} />
															{searchText && <ClearSearchButton {...toolkitProps.searchProps} className="clear-search" />}
														</>
													)}
												</div>

												<PaginationListStandalone {...paginationProps} />
												<div
													style={{
														position: 'relative',
														width: '275px',
														right: '75px'
													}}
												>
													<SizePerPageDropdownStandalone {...paginationProps} />
													<PaginationTotalStandalone dataSize={total} {...paginationProps} />
												</div>
											</div>
										)}
										<BootstrapTable
											classes={'table table-primary table-striped table-sm table-responsive-md'}
											// rowClasses={"d-flex"}
											{...toolkitProps.baseProps}
											{...paginationTableProps}
											remote={{
												sort: true,
												pagination: true,
												search: true
											}}
											onTableChange={this.handleTableChange}
											filter={filterFactory()}
											bootstrap4
											striped
											condensed
											hover
											size="sm"
											hiddenRows={hiddenRows}
											loading={() => !this.state.isLoaded && data.length <= 0}
											noDataIndication={() => <p>No data Available</p>}
											cellEdit={cellEditFactory({
												mode: 'click',
												blurToSave: true,
												// autoSelectText: true,
												timeToCloseMessage: 10000,
												onStartEdit: this.onStartEdit,
												beforeSaveCell: (oldValue, newValue, row, column, done) => this.checkEditability(oldValue, newValue, row, column, done),
												afterSaveCell: (dunno, cell, rowData, colDef) => this.checkUpdate(colDef.dataField, cell, rowData)
											})}
										/>
										{showPagination && (
											<div
												style={{
													display: 'flex',
													flexDirection: 'row',
													justifyContent: 'space-between',
													flexWrap: 'wrap'
												}}
											>
												<CustomCsvButton {...toolkitProps.csvProps} />
												<PaginationListStandalone {...paginationProps} />
												<div
													style={{
														position: 'relative',
														width: '275px',
														right: '75px'
													}}
												>
													<SizePerPageDropdownStandalone {...paginationProps} />
													<PaginationTotalStandalone dataSize={total} {...paginationProps} />
												</div>
											</div>
										)}
									</div>
								);
							}}
						</ToolkitProvider>
					)}
				</PaginationProvider>

				<AmendmentInfo count={amendments} />
				<div className="SelectButtonCell">
					{this.areRowsHidden() ? (
						<UnhideButton onClick={this.unhideRows} numberOfUpdates={amendments} />
					) : (
						hasAmendments && (
							<>
								<button
									style={{ height: '45px', width: '150px' }}
									onClick={this.previewClick}
									className={`react-bs-table-csv-btn btn btn-default btn btn-primary btn-sm`}
								>
									{inPreview ? 'Remove Preview' : 'Show Preview'}
								</button>

								<button
									style={{ height: '45px', width: '150px' }}
									onClick={this.removeAllEdits}
									className={`react-bs-table-csv-btn btn btn-default btn btn-secondary btn-sm`}
								>
									Remove All Edits
								</button>
							</>
						)
					)}
				</div>
			</div>
		);
	}
}

export default ContractsDataTable;
